import React from "react";

const TrendsTable = ({ content }) => {
  return (
    <div className="p-4 p-sm-5 pb-sm-4 mb-4" style={{ backgroundColor: "#F4F4F6" }}>
      <table className="w-100" >
        <thead>
          <tr>
            {content.headers.map((header) => (
              <th className="pb-3" key={header}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-gray-800">
          <tr>
            <td colSpan={content.headers.length}>
              <div
                className="border-top border-5 mb-2"
                style={{
                  borderImageSlice: 1,
                  borderImageSource:
                    "linear-gradient(90deg, #43128E 0%, #A014FD 50%, #3AE1F9 96.15%)",
                }}
              />
            </td>
          </tr>

          {content.rows.map((columns, idx) => (
            <tr key={idx}>
              {columns.map((item) => (
                <td key={item} className="py-3 text-sm">
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TrendsTable
